import { Slide, PptxFile } from '../types';
import {
  Category,
  TableChart,
  TextFields,
  Image,
  BarChart,
  HelpOutline,
} from "@mui/icons-material";
import React from 'react'; // Import React for JSX

export const getMissingFormDataSlides = (slides: Slide[], pptxFile: PptxFile | null): number[] => {
  if (!pptxFile) return [];
  return slides
    .map((slide, index) => {
      if (!slide.pptxSlideNumber) return null;
      const slideTemplate = pptxFile.parsedSlides[slide.pptxSlideNumber - 1];
      if (!slideTemplate) return null;
      const hasEmptyElements = slideTemplate.elements.some(element => 
        !slide.formData?.[element.name]
      );
      return hasEmptyElements ? index : null;
    })
    .filter((index): index is number => index !== null);
};

export const getUnassignedSlides = (slides: Slide[]): number[] => {
  return slides
    .map((slide, index) => (slide && !slide.pptxSlideNumber && slide.contentDescription ? index : null))
    .filter((index): index is number => index !== null);
};

export const getSlidesMissingDescription = (slides: Slide[]): number[] => {
  return slides
    .map((slide, index) => (!slide.contentDescription ? index : null))
    .filter((index): index is number => index !== null);
};

export const createNewSlide = (contentDescription?: string): Slide => {
  return {
    formData: {},
    contentDescription,
    pptxSlideNumber: undefined,
  };
};

// Helper function to determine the effective locked state of a slide element
export const isElementLocked = (
  element: { name: string; isLocked?: boolean } | undefined,
  slide: Slide
): boolean => {
  if (!element) return false; // If element data is missing, treat as not locked

  const isDefaultLocked = element.isLocked === true;
  const isInOverrideList = slide.lockedElementNames?.includes(element.name) || false;

  // If default is locked, it's locked UNLESS explicitly unlocked (present in override list).
  // If default is unlocked, it's locked ONLY IF explicitly locked (present in override list).
  return isDefaultLocked ? !isInOverrideList : isInOverrideList;
};

// Function to get the appropriate icon based on element type
export function getElementTypeIcon(
  type: "shape" | "table" | "text" | "picture" | "chart" | string
): React.ReactNode {
  switch (type) {
    case "shape":
      return <Category fontSize="small" />;
    case "table":
      return <TableChart fontSize="small" />;
    case "text":
      return <TextFields fontSize="small" />;
    case "picture":
      return <Image fontSize="small" />;
    case "chart":
      return <BarChart fontSize="small" />;
    default:
      return <HelpOutline fontSize="small" />;
  }
}